import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "../pages/login/LoginPage";
import SsoSignInPage, { SsoSignOutPage } from "../pages/login/SsoSignInPage";
import OAuthCallbackPage from "../pages/oauth/OAuthCallbackPage";
import LandingPage from "../pages/landing/LandingPage";
import ClassesPage from "../pages/classes/ClassesPage";
import PeriodClosedPage from "../pages/closed/PeriodClosedPage";
import Layout from "../layout/Layout";
import { ProtectedRoute } from "../layout/ProtectedRoute";
import { RequireAccess } from "../layout/RequireAccess";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            {/* SSO (VNPT / Nam Việt) — redirect đi cổng đăng nhập tập trung + xử lý callback ?code= */}
            <Route path="/signin-oidc" element={<SsoSignInPage />} />
            <Route path="/signout-oidc" element={<SsoSignOutPage />} />
            <Route path="/oauth-callback" element={<OAuthCallbackPage />} />
            <Route path="/closed" element={<PeriodClosedPage />} />
            <Route
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="/" element={<LandingPage />} />
                <Route
                    path="/classes"
                    element={
                        <RequireAccess>
                            <ClassesPage />
                        </RequireAccess>
                    }
                />
                {/* /my-registrations đã merge vào /classes (3-section combined giống Old) */}
                <Route
                    path="/my-registrations"
                    element={<Navigate to="/classes" replace />}
                />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
